module.exports = __webpack_public_path__ + "img/rbk_money.03a76f50.jpg";